import { type ReactNode, useState } from 'react';

import InfoCircle from '@/assets/svg/bx-info-circle.svg?react';
import { Button, type ButtonProps } from '@/components/buttons';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';
import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

type ActionType = 'hover' | 'focus' | 'click' | 'contextMenu';

type Props = {
  className?: string;
  title: ReactNode;
  body: ReactNode;
  trigger?: ActionType | ActionType[];
  onClick?: ButtonProps['onClick'];
};

const InfoPopover = ({ className, title, body, trigger = 'click', onClick }: Props) => {
  const triggerList = Array.isArray(trigger) ? trigger : [trigger];
  const openOnHover = triggerList.includes('hover');
  const isContextMenuOnlyTrigger = triggerList.includes('contextMenu') && triggerList.length === 1;
  const [open, setOpen] = useState(false);

  return (
    <Popover
      modal={false}
      open={isContextMenuOnlyTrigger ? open : undefined}
      onOpenChange={isContextMenuOnlyTrigger ? setOpen : undefined}
    >
      <PopoverTrigger
        openOnHover={openOnHover}
        render={
          <Button
            variant="ghost"
            className={cn('-my-0.5 text-aqua-400!', className)}
            size="icon-small"
            onClick={onClick}
            onContextMenu={(event) => {
              if (!isContextMenuOnlyTrigger) {
                return;
              }
              event.preventDefault();
              setOpen(true);
            }}
          >
            <InfoCircle />
          </Button>
        }
      />
      <PopoverContent side="right" className="dark max-w-60 p-5">
        <div className="flex flex-col gap-2">
          <Text variant="caption1" color="light-green">
            {title}
          </Text>
          <Text variant="body2" color="white">
            {body}
          </Text>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default InfoPopover;
